import { NodeReference } from '../decorators/change-tracker';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { ISweepFeature } from '../kb3d-models';
import { SketchNode } from '../meshes/sketch-node';
import { Token } from '../token';
import { BaseConnector } from './base-connector';
import { ExtrudeFeature } from './extrude-feature';
import { ALL_GEOMETRY, eMeshChangeTypes } from './feature';

@Kb3dModel({
    token: Token.SweepFeature,
})
export class SweepFeature extends ExtrudeFeature implements ISweepFeature {
    static _affects = new Set(ALL_GEOMETRY);
    static _affectedBy = new Set([...ALL_GEOMETRY, eMeshChangeTypes.Transform]);

    @NodeReference(BaseConnector) start?: string;
    @NodeReference(BaseConnector) end?: string;
    @NodeReference(SketchNode) path?: string;

    size = 0;
    mitredExtrusion: boolean;
}
